import type ModuleTypes from "website_script/constants/ModuleTypes"
import type { ClickTrackingData } from "widgets/TradeInValuations/Utility/clickTrackingData"
import { FlowType } from "./scalars"
import {
  ActionType,
  ActionExecutionType,
} from "DealerApp/Settings/webModules/operations/getOptions"

export enum FlowEventAction {
  valuationDone = "valuationDone",
  valuationFailed = "valuationFailed",
  formOpen = "formOpen",
  carDetailsStarted = "carDetailsStarted",
  carDetailsSent = "carDetailsSent",
  customerDetailsSent = "customerDetailsSent",
  unavailable = "unavailable",
  bookTestDriveStarted = "bookTestDriveStarted",
  bookTestDriveDone = "bookTestDriveDone",
  setPriceAlertStatus = "setPriceAlertStatus",
  startFlow = "startFlow",
  /** When the (non lead) flow is completed */
  completeFlow = "completeFlow",
  /**
   * Generic lead flow events
   */
  /** When the lead flow is opened in a modal */
  leadFlowOpened = "leadFlowOpened",
  /** When the lead flow is loaded */
  leadFlowStarted = "leadFlowStarted",
  /** When the lead details are submitted by the user (but not necessarily verified) */
  leadFlowSubmitted = "leadFlowSubmitted",
  /** Deprecated, please use onLoadFlowCompleted */
  leadFlowDone = "leadFlowDone",
  /** When the lead is ready to be delivered to the dealer (verified) */
  leadFlowCompleted = "leadFlowCompleted",
  /** Event fired when we need to start checking for verification */
  checkForLeadVerification = "checkForLeadVerification",
}

export type GenericFlowEventAction =
  | FlowEventAction.leadFlowOpened
  | FlowEventAction.leadFlowStarted
  | FlowEventAction.leadFlowSubmitted
  | FlowEventAction.leadFlowDone
  | FlowEventAction.leadFlowCompleted
  | FlowEventAction.checkForLeadVerification

export type FlowEvent = {
  /** event description */
  action: FlowEventAction
  data: unknown
}

/** Flow context data passed to an event */
export type FlowEventContext = {
  flowType: ModuleTypes
  departmentId: string | null
  carId: string | null
  carUrl: string
  completionSource?: string
  customerId: string
  clickTrackingData: ClickTrackingData
  dateTime: string
  dataFromSource?: string
  leadFlowId?: string
  requiresEmailVerification?: boolean
  checkLeadVerificationUrl?: string
}

export type GenericFlowEvent = FlowEvent & {
  action: GenericFlowEventAction
  data: {
    customerDetails: unknown
    flowContext: FlowEventContext
  }
}

export type StartFlowData = {
  flow_type: FlowType
  lead_id: string | null
  lead_token: string | null
  action_type: ActionType
  action_execution?: ActionExecutionType
  url?: string
  js_snippet?: string
  open_in_new_tab?: boolean
}
